<template>
	<el-cascader
		ref="cascader"
		class="cascader-hy"
		v-model="model"
		:placeholder="placeholder"
		:options="options"
		:props="props"
		clearable
		@change="changeHandler"
	></el-cascader>
</template>

<script>
import MODEL from '@/mixins/model'
import TWO_WAY from '@/mixins/2way'

export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		}
	},
	mixins: [MODEL, TWO_WAY],
	data() {
		return {
			options: [],
			props: {
				emitPath: false,
				value: 'id',
				label: 'text'
			}
		};
	},
	computed: {
		model: {
			get() {
				if(getType(this.value) === 'string')
					return this.value.trim();
				else 
					return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}
		}
	},
	methods: {
		queryData(node, resolve) {
			this.$get(`${this.getGetters('mngUrl')}/revision/tree/queryNewZbBdType.json`, data => {
				var arr;
				try{
					arr = JSON.parse(data);
				} catch(e) {
					arr = data;
				};

				this.options = arr;
			});
		},
		changeHandler() {
			// console.log(row)
			this.$nextTick(() => {
				const selNode = this.$refs.cascader.getCheckedNodes()[0];
				selNode && this.twoWayHandler(selNode.data);
				var val = selNode.pathLabels.join("/")
				this.$emit('bdsorname',val)
			})
		}
	},
	created() {
		this.queryData();
	}
}
</script>

<style>
	.cascader-hy{width:100%;}
</style>
